import * as React from "react";
import { Nav, INavStyles, INavLink } from "@fluentui/react/lib/Nav";
import { useNavigate } from "react-router-dom";
import COLORES from "../../utils/theme/colores";
import { AuthContext } from "../../auth/context/auth-context";

const navStyles: Partial<INavStyles> = {
  root: {
    width: "230px",
    height: "calc(100vh - 3rem)",
    maxwidth: "300px",
    boxSizing: "border-box",
    border: "1px solid #eee",
    overflowY: "auto",
    cursor: "pointer",
    backgroundColor: COLORES.Bases.BackgroundNavOutlook,
  },
  groupContent: {
    marginBottom: "15px",
    padding: "0 10px 0 0",
  },
  link: {
    paddingLeft: "25px",
    height: "25px",
    borderRadius: "10xp",
    font: "inherit",
    margin: 5,
  },
  chevronButton: {
    fontSize: "14px",
    height: "35px",
    borderRadius: "10xp",
  },
};

const Sidebar: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { access } = React.useContext(AuthContext);
  const _clickNavigate = (
    ev?: React.MouseEvent<HTMLElement>,
    item?: INavLink
  ) => {
    if (ev) {
      ev.preventDefault();
      if (item) {
        navigate(item.url);
      }
    }
  };

  return (
    <Nav
      styles={navStyles}
      groups={access && access.sidebar ? access.sidebar : []}
      /* groups={navLinkGroups}  */
      onLinkClick={_clickNavigate}
      ariaLabel="Nav example similar to one found in this demo page"
    />
  );
};

export default Sidebar;
